import { Drawer as DrawerWrapper } from "@mui/material";
import { ReactNode } from "react";

type DrawerPropsType = {
  open: boolean;
  onCloseCb: () => void;
  children?: ReactNode;
  style?: Record<string, string>;
};

const Drawer = ({ open, onCloseCb, children, style }: DrawerPropsType) => {
  return (
    <DrawerWrapper
      open={open}
      hideBackdrop
      onClose={onCloseCb}
      anchor={"right"}
      sx={{
        ...style,
        // Pin the paper to the *visible* viewport. On iOS Safari 100vh is
        // taller than the visible area, which pushed drawer content (and the
        // submit button) behind the browser toolbar.
        "& .MuiDrawer-paper": {
          height: "100%",
          maxHeight: "100dvh",
        },
      }}
    >
      {children}
    </DrawerWrapper>
  );
};

export default Drawer;
